<template>
<div id="app">
    <page-controll/>
</div>
</template>
<script>
import pageControll from './views/PageControll'
export default {
  name: 'app',
  components:{
      'pageControll':pageControll
  }
}
</script>
